import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const solutionStore = createApi({
    reducerPath: 'solutionStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        getSolutionRoleTitles: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptBlueSolution/getSolutionRoleTitles/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        }),
        updateSolutionRoleTitles: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptBlueSolution/updateSolutionRoleTitles/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        }),
        updateSolutionRoleTitleStatus: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptBlueSolution/updateSolutionRoleTitleStatus/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        }),
        getManualInstanceVariables: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptBlueSolution/getManualInstanceVariables/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        }),
        updateManualInstanceVariables: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptBlueSolution/updateManualInstanceVariables/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        }),
        updateManualInstanceVariableStatus: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptBlueSolution/updateManualInstanceVariableStatus/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        })
    }),
})

export const {
    useGetSolutionRoleTitlesMutation,
    useUpdateSolutionRoleTitlesMutation,
    useUpdateSolutionRoleTitleStatusMutation,
    useGetManualInstanceVariablesMutation,
    useUpdateManualInstanceVariablesMutation,
    useUpdateManualInstanceVariableStatusMutation,
} = solutionStore;